module.exports = __webpack_public_path__ + "img/slide1_8.41c8bf1a.png";